export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Ebook_Writing_en-US.5a83a9a.vtt";